import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { deviceScheduledTasksReducer } from './device-scheduled-tasks.reducer';
import { DeviceScheduledTasksEffects } from './device-scheduled-tasks.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('deviceScheduledTasks', deviceScheduledTasksReducer),
    EffectsModule.forFeature([DeviceScheduledTasksEffects]),
  ],
  providers: [],
})
export class DeviceScheduledTasksStoreModule {}
